/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocsReadResult } from '../../models/docs-read-result';

export interface ApiDocsReadGet$Params {

/**
 * Full absolute URL of the doc page (must be on the configured Docs:BaseUrl host).
 */
  url?: string;
}

export function apiDocsReadGet(http: HttpClient, rootUrl: string, params?: ApiDocsReadGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DocsReadResult>> {
  const rb = new RequestBuilder(rootUrl, apiDocsReadGet.PATH, 'get');
  if (params) {
    rb.query('url', params.url, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocsReadResult>;
    })
  );
}

apiDocsReadGet.PATH = '/api/Docs/read';
